import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import SectionTitle from '../../../components/ui/section-title'
import FeaturedBlog from '../../../components/blog/layout-three'
import RecentBlog from '../../../components/blog/layout-four'
import { BlogWrap, BlogList, BlogListItem } from './blog-area.style'

const BlogArea = (props) => {
    const BlogData = useStaticQuery(graphql`
        query ServicesBlogQuery {
            section: indexServicesJson(id: {eq: "services-blog-contnet"}) {
                title
                subtitle
            }
            featureBlog: allMarkdownRemark(filter: {frontmatter: {is_featured: {eq: true}}}, limit: 1) {
                edges {
                    node {
                        fields {
                            slug
                            dateSlug
                        }
                        frontmatter {
                            title
                            date(formatString: "LL")
                            format
                            featured_image {
                                childImageSharp {
                                    fluid(maxWidth: 690, maxHeight: 422, quality: 100, srcSetBreakpoints: 6) {
                                        ...GatsbyImageSharpFluid_withWebp
                                        presentationWidth
                                        presentationHeight
                                    }
                                }
                            }
                            author {
                                name
                                fields {
                                    authorId
                                }
                                image {
                                    childImageSharp {
                                        fixed(width: 32, height: 32, quality: 100) {
                                            ...GatsbyImageSharpFixed_withWebp
                                        }
                                    }
                                }
                            }
                        }
                        excerpt
                    }
                }
            }
            posts : wpcontent {
                        posts(first: 5) {
                          edges {
                            node {
                              id
                              excerpt(format: RENDERED)
                              featuredImage {
                                node {
                                  id
                                  mediaDetails {
                                    file
                                  }
                                  sourceUrl
                                  imageFile {
                                    childImageSharp {
                                      fluid(maxWidth: 528, maxHeight: 343, quality: 100, srcSetBreakpoints: 6) {
                                        presentationWidth
                                        presentationHeight
                                        ...GatsbyImageSharpFluid_withWebp
                                      }
                                    }
                                  }
                                }
                              }
                              title(format: RENDERED)
                              author {
                                node {
                                  id
                                  name
                                  avatar {
                                    url
                                  }
                                }
                              }
                              slug
                              date
                            }
                          }
                        }
                      }
            recentBlogs: allMarkdownRemark(filter: {frontmatter: {is_featured: {ne: true}, format: {eq: "image"}}}, limit: 3) {
                edges {
                    node {
                        fields {
                            dateSlug
                            slug
                        }
                        frontmatter {
                            title
                            date(formatString: "LL")
                            format
                            author {
                                name
                                fields {
                                    authorId
                                }
                                image {
                                    childImageSharp {
                                        fixed(width: 32, height: 32, quality: 100) {
                                            ...GatsbyImageSharpFixed_withWebp
                                        }
                                    }
                                }
                            }
                            featured_image {
                                childImageSharp {
                                    fluid(maxWidth: 528, maxHeight: 343, quality: 100, srcSetBreakpoints: 6) {
                                        presentationWidth
                                        presentationHeight
                                        ...GatsbyImageSharpFluid_withWebp
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }      
    `)

    const { title, subtitle } = BlogData.section;
    const featureBlogs = BlogData.featureBlog.edges;
    const recentBlogs = BlogData.recentBlogs.edges;
    const posts = BlogData.posts.posts.edges;
    const featuredPost = posts[0];
    const recentPosts = posts.slice(1);
    const { sectionTitleStyle } = props;
    return (
        <BlogWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            {...sectionTitleStyle}
                            title={title}
                            subtitle={subtitle}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col lg={6}>
                            <FeaturedBlog
                                key={featuredPost.node.slug}
                                format="image"
                                title={featuredPost.node.title}
                                slug={featuredPost.node.slug}
                                date={featuredPost.node.date}
                                dateSlug={featuredPost.node.date}
                                author={featuredPost.node.author.node}
                                featured_image={featuredPost.node.featuredImage.node.imageFile.childImageSharp.fluid}
                                excerpt={featuredPost.node.excerpt}
                            />
                    </Col>
                    <Col lg={6}>
                        <BlogList>
                            {recentPosts && recentPosts.map(recentBlog => (
                                <BlogListItem key={recentBlog.node.slug}>
                                    <RecentBlog
                                        format="image"
                                        title={recentBlog.node.title}
                                        slug={recentBlog.node.slug}
                                        date={recentBlog.node.date}
                                        dateSlug={recentBlog.node.dateSlug}
                                        author={recentBlog.node.author.node}
                                        featured_image={recentBlog.node.featuredImage.node.imageFile.childImageSharp.fluid}
                                    />
                                </BlogListItem>
                            ))}
                        </BlogList>
                    </Col>
                </Row>
            </Container>
        </BlogWrap>
    )
}

BlogArea.defaultProps = {
    sectionTitleStyle: {
        mb: '60px',
        responsive: {
            small: {
                mb: '47px'
            }
        }
    }
}

export default BlogArea
